import React from "react";
import { Outlet } from "react-router-dom";
import test from "../../assets/images/sidetest.png";
import Header from "./Header";
const HomeLayout: React.FC = () => { 
  return (
    <div>
      <div className="contaner is-fluid smart-pdf-container">
        <div className="full-main">
          <Header />
          <div className='value-main'>
            <h1 className='text-1'>Smart Effortless <br /> PDF Solutions</h1>
            <p>
              Unlock a suite of powerful PDF tools on our platform — merge, compress, <br />
              and manipulate PDFs effortlessly for seamless document management. <br />
              Elevate your PDF experience with simplicity and efficiency.</p>
            <img src={test} />
          </div>
        </div>
        <main className='smart-mainlayout-middle p-5'>    <Outlet /></main>
        <footer className='smart-pdf-footer' >
        </footer>
      </div>
  
    </div>
  );
};

export default HomeLayout;